import config from './config';

// Soonest deadline first, undated last (the route pushes NULLs past the dated
// rows); the list is capped server-side, so this decides what makes the page
async function fetchTasksList({
  cstmrPost,
  filters = {},
  sortBy = [{ key: 'tskEndDue', desc: false }],
  piid,
  rlid,
}) {
  const postArgs = {
    urlPath: config.town.back.tasks.list,
    payload: { filters, sortBy },
  };
  if (piid) {
    postArgs.piid = piid;
    postArgs.rlid = rlid;
  }

  const res = await cstmrPost(postArgs);
  return res.body?.rslt?.data ?? [];
}

export default fetchTasksList;
